/** Navigation bean */
export class NavigationBean {
	/** Disable left navigation flag */
	disableLeftNav: boolean;
	/** Disable right navigation flag */
	disableRightNav: boolean;
	/** Left navigation value */
	leftNavValue: number;
	/** Right navigation flag */
	rightNavValue: number;
}
